import React, { useState, useEffect } from 'react'
import api from '../lib/api'

export default function DashboardPage({ user }) {
  const [progress, setProgress] = useState(null)
  const [wallet, setWallet] = useState(null)
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!user?.id) return
    const fetchData = async () => {
      try {
        setLoading(true)
        setMessage('')
        const [progressResponse, creditsResponse] = await Promise.allSettled([
          api.get(`/progress/${user.id}`),
          api.get('/credits/me')
        ])

        if (progressResponse.status === 'fulfilled') {
          setProgress(progressResponse.value.data)
        } else {
          setProgress(null)
        }

        if (creditsResponse.status === 'fulfilled') {
          setWallet(creditsResponse.value.data.wallet)
        } else {
          setWallet(null)
        }

        if (progressResponse.status === 'rejected' && creditsResponse.status === 'rejected') {
          setMessage('Não foi possível carregar o dashboard agora.')
        } else if (progressResponse.status === 'rejected' || creditsResponse.status === 'rejected') {
          setMessage('Parte do dashboard foi carregada, mas alguns indicadores estão indisponíveis.')
        }
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [user?.id])

  if (loading) return <div className="text-center py-12">Carregando dashboard...</div>

  return (
    <div className="page-stack">
      <h1 className="text-4xl font-bold mb-8">📊 Seu Dashboard</h1>
      {message ? <div className="alert info">{message}</div> : null}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-8 rounded-lg mb-8">
        <h2 className="text-2xl font-bold mb-2">Bem-vindo, {user.name}!</h2>
        <p>Acompanhe progresso, créditos, assinatura e atendimento online no mesmo portal.</p>
      </div>
      <div className="grid md:grid-cols-4 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow-md"><h3 className="text-gray-600 mb-2">Atividades Completadas</h3><p className="text-3xl font-bold">{progress?.totalActivitiesCompleted || 0}</p></div>
        <div className="bg-white p-6 rounded-lg shadow-md"><h3 className="text-gray-600 mb-2">Pontuação Média</h3><p className="text-3xl font-bold">{progress?.averageScore || 0}%</p></div>
        <div className="bg-white p-6 rounded-lg shadow-md"><h3 className="text-gray-600 mb-2">Jogos Completados</h3><p className="text-3xl font-bold">{progress?.totalGamesCompleted || 0}</p></div>
        <div className="bg-white p-6 rounded-lg shadow-md"><h3 className="text-gray-600 mb-2">Créditos</h3><p className="text-3xl font-bold">{wallet?.balance || 0}</p></div>
      </div>
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-6">📚 Últimas Atividades</h2>
        <p className="text-gray-600">Última atividade: {progress?.lastActivityDate ? new Date(progress.lastActivityDate).toLocaleDateString('pt-BR') : 'Nenhuma'}</p>
        <p className="text-gray-600">Badges conquistadas: {progress?.badges?.map((badge) => badge.name).join(', ') || 'Nenhuma badge ainda'}</p>
      </div>
    </div>
  )
}
